/* angular:styles/component:css;e70bcf7cfe02434ed1adcec593612bf7e864b4d9cf87f47910fd178679c30bf8;/app/src/app/shared/layout/overlay-fullscreen-box/overlay-fullscreen-box.component.ts */
.sheet {
  background: #fff;
  z-index: 10000;
  width: 100vw;
  height: 95vh;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.close-btn {
  height: 24px;
  width: 24px;
  border-radius: 12px;
  text-align: right;
  margin: 8px 8px 0 0;
}
.close-icon {
  color: #333;
}
.content {
  margin: 8px 0 0 0;
  height: 100%;
}
/*# sourceMappingURL=overlay-fullscreen-box.component.css.map */
